import appStore from 'store';
import api from './api';
import {
  PAGINATION
} from './constants';

const store = {
  namespaced: true,
  state: {
    userList: [],
    totalCount: 0,
    pagination: PAGINATION,

  },
  getters: {

  },
  mutations: {
    setUserList(state, payload) {
      console.log('payload.list',payload.list);
      state.userList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setQueryType(state, payload) {
      state.queryType = payload;
    },
    setUserinfoDetailDialogVisible(state, payload) {
      state.userinfoDetailDialogVisible = payload;
    },
    setdialogVisible(state, payload) {
      state.dialogVisible = payload;
    },
    setnodedetail(state, payload) {
      state.notedetail = payload;
    },
    setUserinfoDetail(state, payload) {
      state.userinfoDetail = payload;
    },
    setCountryCodeList(state, payload) {
      state.countryCodeList = payload;
    }
  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size });
      api.getUserList(query).then(res => {
        console.log('payload.list',res);
        if(res.code==0){
          commit('setUserList', res.data);
        }
      });
    },
    addRemark({commit},data){
     return api.addRemark(data).then(res=>{
        return res
      })
    }
 
  }
};

appStore.registerModule('funds', store);
